import React from "react";
import NotificationAlert from "../notification/NotificationAlert";
import { chainWalk } from "../util/Util";
import { getShiftPlanningURL } from "../util/Util";

const getHeadCountsSum = (headCountData) => {
  return Object.keys(headCountData)
    .map((role) => headCountData[role])
    .reduce((a, b) => a + b, 0);
};

const getNumAssociates = (diff) => {
  let data = diff.data;
  if (!diff || !diff.data || !diff.plan1 || !diff.plan2) {
    return "";
  }
  let time = Object.keys(data["CYCLE_1"])[0];
  let headCountData1 = data["CYCLE_1"][time][diff.plan1.planId];
  let headCountData2 = data["CYCLE_1"][time][diff.plan2.planId];
  let count =
    getHeadCountsSum(headCountData1) - getHeadCountsSum(headCountData2);
  return count !== 0 ? Math.abs(count) : "";
};

const DynamicShiftPlanNotification = ({ notification }) => {
  const diff = notification.diff;
  const shiftPlanningLink = getShiftPlanningURL();
  if (!diff || Object.keys(diff).length === 0) {
    return null;
  }
  if (diff.planActedUpon) {
    return null;
  }
  const numAssociates = chainWalk(() => getNumAssociates(diff), "");
  return (
    <NotificationAlert
      title={"Labor Change Alert"}
      message={`We have detected a change in labor needed to maintain flow. 
                ${numAssociates} Associates need to be reallocated. `}
      link={shiftPlanningLink}
      openNewTab={false}
      linkMessage={"Review & accept suggested changes here"}
    />
  );
};
export default DynamicShiftPlanNotification;



// WEBPACK FOOTER //
// ./src/components/dynamicShiftPlanning/DynamicShiftPlanNotification.js